import type { Partner } from "@expert/shared-types";

import { getPartnerTool } from "../utils";

export const MAX_SUMMARY_LENGTH = 930;
/** Time to prevent scheduling callback before ending call in seconds */
export const CALLBACK_CUTOFF = 2;

export function getNotificationText(
    partner: Partner,
    isValidAccountNumber: boolean,
    { useMdnForAccountNo = false, hasPrimaryAccountHolder = false } = {},
) {
    // TODO: This is a hack to make sure AT&T continues to get the expected messaging,
    // Partner should NOT be referenced directly in the codebase
    if (partner === "att") {
        // Without a primary account holder, ATT's API rejects the session summary request to save notes in OPUS
        if (useMdnForAccountNo && !hasPrimaryAccountHolder) {
            return `Auto-send failed. Please copy and paste to ${getPartnerTool(partner)} manually.`;
        }
        return `Summary will be sent to ${getPartnerTool(partner)}`;
    }

    // TODO: This is a hack to make sure Verizon continues to get the expected messaging,
    // Partner should NOT be referenced directly in the codebase
    if (partner === "verizon") {
        if (isValidAccountNumber) {
            return `Summary will be sent to ${getPartnerTool(partner)}`;
        }
        return `Auto-send failed. Please copy and paste to ${getPartnerTool(partner)} manually.`;
    }

    return "Copy summary";
}

interface CallDetails {
    category?: {
        name?: string;
    };
    subCategory?: {
        name?: string;
    };
}

export function adaptSimplifiedSummary(generatedSummary: string): {
    subject: string;
    summary: string;
    category?: string;
    subcategory?: string;
} {
    const parsedSummary = JSON.parse(generatedSummary) as {
        Subject?: string;
        Problem?: string;
        Cause?: string;
        Action?: string;
        Resolution?: string;
        Status?: string;
        callDetails?: CallDetails;
    };
    const subject = parsedSummary?.Subject ?? "";
    const problem = parsedSummary?.Problem ?? "";
    const cause = parsedSummary?.Cause ?? "";
    const action = parsedSummary?.Action ?? "";
    const resolution = parsedSummary?.Resolution ?? "";

    return {
        summary: `Problem: ${problem}\nCause: ${cause}\nAction:\n${action}\n\nResolution:\n${resolution}`,
        subject,
        category: parsedSummary.callDetails?.category?.name,
        subcategory: parsedSummary.callDetails?.subCategory?.name,
    };
}
